import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const scrollContainerDefaultVariants = {
  "size": "element"
}
const scrollContainerCompoundVariants = []

const scrollContainerSlotNames = [
  [
    "root",
    "scroll-container__root"
  ]
]
const scrollContainerSlotFns = /* @__PURE__ */ scrollContainerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, scrollContainerDefaultVariants, getSlotCompoundVariant(scrollContainerCompoundVariants, slotName))])

const scrollContainerFn = memo((props = {}) => {
  return Object.fromEntries(scrollContainerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const scrollContainerVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...scrollContainerDefaultVariants, ...compact(variants) })

export const scrollContainer = /* @__PURE__ */ Object.assign(scrollContainerFn, {
  __recipe__: false,
  __name__: 'scrollContainer',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: scrollContainerVariantKeys,
  variantMap: {
  "size": [
    "element",
    "page"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, scrollContainerVariantKeys)
  },
  getVariantProps
})